import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";
import { Box } from "@mui/material";
const RequiredLabel = ({ label }) => (
  <span>
    {label}{" "}
    <span style={{ color: "red", fontSize: "14px", fontWeight: "bold" }}>
      *
    </span>
  </span>
);

const FormikDatePicker = ({ name, label, formik, required, disabled }) => {
  const hasError = Boolean(
    formik.touched[name] && Boolean(formik.errors[name])
  );
  console.log(dayjs(formik.values[name]), "dayjs(formik.values[name])");
  console.log(formik.values[name], "formik.values[name]");
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        error={hasError === true}
        format="DD/MM/YYYY"
        size="small"
        disabled={disabled}
        views={["year", "month", "day"]} // Ensures it cycles properly
        label={required ? <RequiredLabel label={label} /> : label}
        value={dayjs(formik.values[name]) || ""}
        sx={{
          ".MuiInputBase-input": {
            padding: "8.5px 14px",
          },
          width: "100%",
          color: "black",
        }}
        slotProps={{
          textField: {
            error: hasError, // Properly handling error state
            helperText: hasError ? formik.errors[name] : "",
          },
        }}
        onChange={(dateValue, context) => {
          formik.setFieldValue(name, dateValue);
        }}
      />
    </LocalizationProvider>
  );
};

export default FormikDatePicker;
